import { sv } from 'date-fns/locale/sv';

const formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' HH.mm",
    yesterday: "'igår kl.' HH.mm",
    today: "'idag kl.' HH.mm",
    tomorrow: "'imorgon kl.' HH.mm",
    nextWeek: "EEEE 'kl.' HH.mm",
    other: 'Pp',
};

function formatRelative(token: string) {
    return formatRelativeLocale[token];
}

const newSv = {
    ...sv,
    formatRelative,
};

export default newSv;
